/*eslint-disable */
import React, { useEffect, useState } from "react";
import { withFormik, Form as Formiker, Field as Fieldmik } from "formik";
import * as yup from "yup";
import moment from "moment";
import {
  Form as FormUi,
  Container,
  TextArea,
  Button,
  Input,
  Segment,
  Dropdown,
  Icon,
  Search,
} from "semantic-ui-react";
import "react-datepicker/dist/react-datepicker.css";
import InsertJobOrders from "./insertOrder";
import InsertEditOrder from "./insertEditOrders";
// import InsertDocument from "./documentdetail";
import { DateData } from "../dynamicComponent/datepick";
import { MyNormalInput } from "../dynamicComponent/myInputs";
import {
  createShipmentDispatcher,
  deleteAllOrderDispatcher,
} from "../../redux/actions/shipmentAction";
import { connect } from "react-redux";
import SearchDropdown from "./searchDropdown";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import ReadAxios from "../axiosComponent/read";
import CreatAxios from "../axiosComponent/create";
import UpdateAxios from "../axiosComponent/update";
import { translate } from "react-i18next";
// TODO: make call from redux
import { min, isEmpty } from "lodash";
import MandatoryMark from "../common/mandatorymark";
import ModalDiscardOrder from "./orderDiscardConfirmation";

const EditInsertShipment = ({
  values,
  vehicleTypeMaster,
  setFieldValue,
  touched,
  errors,
  handleSubmit,
  shipment,
  shipmentEdit,
  routeCodes,
  routeNames,
  mode,
  isSubmitting,
  deleteAllOrderDispatcher,
  t,
  props
}) => {
  const [deleteModal, setdeleteModal] = useState(false);
  const [movementType, setmovementType] = useState("primary");
  const [disable, setmovementTypedisable] = useState(false);
  const [shipmentdata, setShipment] = useState({});

  useEffect(() => {
    setFieldValue('required_on', new Date())
    if (Number(localStorage.getItem("customerNumber")) == 1158 || Number(localStorage.getItem("customerNumber")) == 1123) {
      setmovementTypedisable(true);
    }
  }, [])
  const setSourceDestination = async (name, value) => {
    if (value) {
      const { key, raw } = value;
      let checkPointsArray = await ReadAxios({
        url: `routeManager/${raw.routeMasterId}`,
      });
      checkPointsArray = isEmpty(checkPointsArray)
        ? []
        : checkPointsArray.data.resultSet;
      setFieldValue(name, key);
      setFieldValue("source", checkPointsArray[0].checkPointName);
      setFieldValue(
        "destination",
        checkPointsArray[checkPointsArray.length - 1].checkPointName
      );
    } else {
      setFieldValue(name, value);
      setFieldValue("source", "");
      setFieldValue("destination", "");
    }
  };

  const checkForOrder = (name, data) => {
    setmovementType(data.value);
    if (
      shipment &&
      shipment.create &&
      shipment.create.orders &&
      shipment.create.orders.length > 0
    ) {
      setdeleteModal(true);
    } else {
      setFieldValue("movement_type", data.value);
    }
  };

  let handleFileUpload = (event) => {
    console.log(event.currentTarget.files[0]);
    // this.setState({useravtar: event.currentTarget.files[0]})
  };

  const handleDeleteSubmit = () => {
    deleteAllOrderDispatcher();
    setdeleteModal(false);
    setFieldValue("movement_type", movementType);
  };

  const handleDeleteClose = () => {
    setdeleteModal(false);
  };

  return (
    <React.Fragment>
      <Formiker>
        <Segment>
          <div className="ui form tiny p-bold-600">
            <FormUi.Group>
              <FormUi.Field width={3}>
                <label className="labelName mt-2">
                  {t("shipment_form.movement_type.title") || "Movement Type"}{" "}
                  <MandatoryMark />
                </label>
              </FormUi.Field>
              <FormUi.Field
                width={4}
                error={
                  touched.movement_type && errors.movement_type ? true : false
                }
              >
                <Dropdown
                  name="movement_type"
                  clearable
                  style={{ width: "100%", fontWeight: "normal" }}
                  disabled={disable}
                  selection
                  placeholder={
                    t("shipment_form.movement_type.placeholder") ||
                    "Movement Type"
                  }
                  onChange={(name, data) => checkForOrder(name, data)}
                  options={[
                    { key: "2", text: "Import", value: "import" },
                    { key: "3", text: "Primary", value: "primary" },
                  ]}
                  value={values.movement_type}
                />
                {touched.movement_type && errors.movement_type ? (
                  <div className="w3-small w3-text-red">
                    {t(
                      `shipment_form.movement_type.error_msg.${errors.movement_type}`
                    ) || errors.movement_type}
                  </div>
                ) : null}
              </FormUi.Field>
              <FormUi.Field width={1} />
              <FormUi.Field width={3}>
                <label className="labelName mt-2">
                  {values.movement_type == "import" ? (
                    <>
                      {t("shipment_form.estimate_clearence_date.title") || "Estimated Clearance End Date"}{""}
                      <MandatoryMark />
                    </>
                  ) : (
                      <>
                        {t("shipment_form.required_on.title") || "Required On"}{" "}
                        <MandatoryMark />
                      </>
                    )}

                </label>
              </FormUi.Field>
              <FormUi.Field
                width={4}
                error={touched.required_on && errors.required_on ? true : false}
                className="datepic"
              >
                <DateData
                  name="required_on"
                  autoComplete="off"
                  showTimeSelect
                  timeFormat="HH:mm"
                  popperClassName="dateTime"
                  dateFormat="dd/MM/yyyy HH:mm"
                  timeIntervals={5}
                  customInput={
                    <Input
                      icon="time"
                      // className="dateWidth"
                      iconPosition="left"
                    />
                  }
                />
                {touched.required_on && errors.required_on ? (
                  <div className="w3-small w3-text-red">
                    {t(
                      `shipment_form.required_on.error_msg.${errors.required_on}`
                    ) || errors.required_on}
                  </div>
                ) : null}
              </FormUi.Field>
            </FormUi.Group>
            <FormUi.Group>
              <FormUi.Field width={3}>
                <label className="labelName mt-2">
                  {t("shipment_form.route_code.title") || "Route"}{" "}
                  <MandatoryMark />
                </label>
              </FormUi.Field>
              <FormUi.Field
                width={4}
                error={touched.route_code && errors.route_code ? true : false}
              >
                <SearchDropdown
                  setField={setSourceDestination}
                  masterRoute="routeMaster"
                  masterRouteKey="routeCode"
                  masterRouteName="routeName"
                  fieldName="route_code"
                  deafultValue={values.route_name}
                />
                {touched.route_code && errors.route_code ? (
                  <div className="w3-small w3-text-red">
                    {t(
                      `shipment_form.route_code.error_msg.${errors.route_code}`
                    ) || errors.route_code}
                  </div>
                ) : null}
              </FormUi.Field>

              <FormUi.Field width={1} />
              <FormUi.Field width={3}>
                <label className="labelName mt-2">
                  {values.movement_type == "import" ? (
                    <>
                      {t("shipment_form.number_of_containers.title") || " No. of Containers"}{" "}
                      <MandatoryMark />
                    </>
                  ) : (
                      <>
                        {t("shipment_form.number_of_vehicles.title") ||
                          "Number Of Vehicles"}{" "}
                        <MandatoryMark />
                      </>
                    )}

                </label>
              </FormUi.Field>
              <FormUi.Field
                width={4}
                error={
                  touched.no_of_vehicles && errors.no_of_vehicles ? true : false
                }
              >
                <Fieldmik
                  component={MyNormalInput}
                  name="no_of_vehicles"
                  type="number"
                  min={0}
                />
                {touched.no_of_vehicles && errors.no_of_vehicles ? (
                  <div className="w3-small w3-text-red">
                    {t(
                      `shipment_form.number_of_vehicles.error_msg.${errors.no_of_vehicles}`
                    ) || errors.no_of_vehicles}
                  </div>
                ) : null}
              </FormUi.Field>
              {/* <FormUi.Field width={3}>
                <label className="labelName mt-2">
                  {t("shipment_form.base_rate.title") || "Base Rate"}
                </label>
              </FormUi.Field>
              <FormUi.Field
                width={4}
                error={touched.base_rate && errors.base_rate ? true : false}
              >
                <Fieldmik
                  component={MyNormalInput}
                  label={{ basic: true, content: "R$" }}
                  labelPosition="left"
                  name="base_rate"
                  type="number"
                  min={0}
                />
                {touched.base_rate && errors.base_rate ? (
                  <div className="w3-small w3-text-red">
                    {t(
                      `shipment_form.base_rate.error_msg.${errors.base_rate}`
                    ) || errors.base_rate}
                  </div>
                ) : null}
              </FormUi.Field> */}
            </FormUi.Group>
            <FormUi.Group>
              <FormUi.Field width={3}>
                <label className="labelName mt-2">
                  {values.movement_type == "import" ? (
                    <>
                      {"Pickup Location"}{" "}
                      <MandatoryMark />
                    </>
                  ) : (
                      <>
                        {t("shipment_form.source.title") || "Source"}{" "}
                        <MandatoryMark />
                      </>
                    )}

                </label>
              </FormUi.Field>
              <FormUi.Field
                width={4}
                error={touched.source && errors.source ? true : false}
              >
                <Fieldmik
                  component={MyNormalInput}
                  name="source"
                  value={values.source}
                  readOnly
                />
                {touched.source && errors.source ? (
                  <div className="w3-small w3-text-red">
                    {t(`shipment_form.source.error_msg.${errors.source}`) ||
                      errors.source}
                  </div>
                ) : null}
              </FormUi.Field>
              <FormUi.Field width={1} />
              <FormUi.Field width={3}>
                <label className="labelName mt-2">
                  {t("shipment_form.destination.title") || "Destination"}{" "}
                  <MandatoryMark />
                </label>
              </FormUi.Field>
              <FormUi.Field
                width={4}
                error={touched.destination && errors.destination ? true : false}
              >
                <Fieldmik
                  component={MyNormalInput}
                  name="destination"
                  value={values.destination}
                  readOnly
                />
                {touched.destination && errors.destination ? (
                  <div className="w3-small w3-text-red">
                    {t(
                      `shipment_form.destination.error_msg.${errors.destination}`
                    ) || errors.destination}
                  </div>
                ) : null}
              </FormUi.Field>
            </FormUi.Group>
            <FormUi.Group>
              <FormUi.Field width={3}>
                {values.movement_type != "import" && (
                  <label className="labelName mt-2">
                    {t("shipment_form.refernce_no.title") || "Reference No"}{" "}
                    {/* <MandatoryMark /> */}
                  </label>
                )}
                {values.movement_type == "import" && (
                  <label className="labelName mt-2">
                    {t("shipment_form.bl_no.title") ||
                      "BL Number"}{" "}
                    {/* <MandatoryMark /> */}

                  </label>
                )}
              </FormUi.Field>
              <FormUi.Field
                error={
                  touched.shipment_reference_no && errors.shipment_reference_no
                    ? true
                    : false
                }
                width={4}
              >
                <Fieldmik
                  component={MyNormalInput}
                  name="shipment_reference_no"
                />
                {touched.shipment_reference_no &&
                  errors.shipment_reference_no ? (
                    <div className="w3-small w3-text-red">
                      {t(
                        `shipment_form.refernce_no.error_msg.${errors.shipment_reference_no}`
                      ) || errors.shipment_reference_no}
                    </div>
                  ) : null}
              </FormUi.Field>
              <FormUi.Field width={1} />
              {/* <FormUi.Field width={3}>
                <label className="labelName mt-2">
                {values.movement_type == "import" ? (
                    <>
                    {" No. of Containers"}{" "}
                    <MandatoryMark />
                    </>
                  ) : (
                  <>
                  {t("shipment_form.number_of_vehicles.title") ||
                    "Number Of Vehicles"}{" "}
                  <MandatoryMark />
                  </>
                  )}
                  
                </label>
              </FormUi.Field>
              <FormUi.Field
                width={4}
                error={
                  touched.no_of_vehicles && errors.no_of_vehicles ? true : false
                }
              >
                <Fieldmik
                  component={MyNormalInput}
                  name="no_of_vehicles"
                  type="number"
                  min={0}
                />
                {touched.no_of_vehicles && errors.no_of_vehicles ? (
                  <div className="w3-small w3-text-red">
                    {t(
                      `shipment_form.number_of_vehicles.error_msg.${errors.no_of_vehicles}`
                    ) || errors.no_of_vehicles}
                  </div>
                ) : null}
              </FormUi.Field> */}
            </FormUi.Group>
            {/* {values.movement_type == "import" && (
              <>
                <FormUi.Group>
                  <FormUi.Field width={3}>
                    <label className="labelName mt-2">
                      {t("shipment_form.bl_no.title") || "BL Number"}
                    </label>
                  </FormUi.Field>
                  <FormUi.Field
                    width={4}
                    error={touched.bl_no && errors.bl_no ? true : false}
                  >
                    <Fieldmik
                      component={MyNormalInput}
                      name="bl_no"
                      value={values.bl_no}
                    />
                    {touched.bl_no && errors.bl_no ? (
                      <div className="w3-small w3-text-red">
                        {t(`shipment_form.bl_no.error_msg.${errors.bl_no}`) ||
                          errors.bl_no}
                      </div>
                    ) : null}
                  </FormUi.Field>
                  <FormUi.Field width={1} />
                  <FormUi.Field width={3}>
                    <label className="labelName mt-2">
                      {t("shipment_form.port_terminal.title") ||
                        "Consignor"}{" "}
                    </label>
                  </FormUi.Field>
                  <FormUi.Field
                    width={4}
                    error={
                      touched.port_terminal && errors.port_terminal
                        ? true
                        : false
                    }
                  >
                    <Fieldmik
                      component={MyNormalInput}
                      name="port_terminal"
                      value={values.port_terminal}
                    />
                    {touched.port_terminal && errors.port_terminal ? (
                      <div className="w3-small w3-text-red">
                        {t(
                          `shipment_form.port_terminal.error_msg.${errors.port_terminal}`
                        ) || errors.port_terminal}
                      </div>
                    ) : null}
                  </FormUi.Field>
                </FormUi.Group>
                <FormUi.Group>
                  <FormUi.Field width={3}>
                    <label className="labelName mt-2">
                      {t("shipment_form.import_declaration_no.title") ||
                        "import_declaration_no"}{" "}
                    </label>
                  </FormUi.Field>
                  <FormUi.Field
                    width={4}
                    error={
                      touched.import_declaration_no &&
                        errors.import_declaration_no
                        ? true
                        : false
                    }
                  >
                    <Fieldmik
                      component={MyNormalInput}
                      name="import_declaration_no"
                      value={values.import_declaration_no}
                    />
                    {touched.import_declaration_no &&
                      errors.import_declaration_no ? (
                        <div className="w3-small w3-text-red">
                          {t(
                            `shipment_form.import_declaration_no.error_msg.${errors.import_declaration_no}`
                          ) || errors.import_declaration_no}
                        </div>
                      ) : null}
                  </FormUi.Field>
                </FormUi.Group>
              </>
            )} */}
            <FormUi.Group>

              <FormUi.Field width={1} />
              {/* <FormUi.Field width={3}>
                <label className="labelName mt-2">
                  {t("shipment_form.remarks.title") || "Remark"}
                </label>
              </FormUi.Field>
              <FormUi.Field
                width={4}
                error={touched.remarks && errors.remarks ? true : false}
              >
                <Fieldmik
                  as={TextArea}
                  className="labelName"
                  name="remarks"
                  id="remarks"
                  defaultValue={""}
                />
                {touched.remarks && errors.remarks ? (
                  <div className="w3-small w3-text-red">
                    {t(`shipment_form.remarks.error_msg.${errors.remarks}`) ||
                      errors.remarks}
                  </div>
                ) : null}
              </FormUi.Field> */}
            </FormUi.Group>
          </div>
        </Segment>
        {mode === 'edit' ? (
          <InsertEditOrder handleSubmit={handleSubmit} mode={mode} moment={values.movement_type == "import" ? 'import' : 'primary'} values={values} vihicle={vehicleTypeMaster} />
        ) : (
            <InsertJobOrders handleSubmit={handleSubmit} mode={mode} moment={values.movement_type == "import" ? 'import' : 'primary'} values={values} vihicle={vehicleTypeMaster} />
          )}
        {/* <InsertJobOrders handleSubmit={handleSubmit} mode={mode} moment={values.movement_type == "import" ? 'import' : 'primary'} values={values} vihicle={vehicleTypeMaster}/> */}
        <ModalDiscardOrder
          OpenModel={deleteModal}
          handleDeleteClose={handleDeleteClose}
          handleDeleteSubmit={handleDeleteSubmit}
        />
        {shipment &&
          shipment.create &&
          shipment.create.orders &&
          shipment.create.orders.length > 0 && (
            <Container className="p-3">
              <div className="row p-center">
                <div className="m-2">
                  <Button
                    type="button"
                    size="mini"
                    className="w3-blue w3-round w3-hover-blue"
                    onClick={() => handleSubmit()}
                  >
                    {t("action_button.save") || "Save"}
                  </Button>
                </div>
              </div>
            </Container>
          )}
      </Formiker>
    </React.Fragment>
  );
};

const FormikEditShipment = withFormik({
  enableReinitialize: true,
  validationSchema: yup.object({
    shipment_reference_no: yup
      .string()
      .optional(),
    required_on: yup.date().required("required"),
    route_code: yup.string().required("required"),
    // proposed_vehicle_type: yup.number().required("required"),
    source: yup.string().required("required"),
    destination: yup.string().required("required"),
    no_of_vehicles: yup.number().required("required").min(1, "min"),
    movement_type: yup.string().required("required"),
    // base_rate: yup.number().optional().nullable(),
    remarks: yup.string().optional().min(5, "min").max(200, "max"),
  }),
  // setFieldValue("required_on", moment().format("DD/MM/yyyy hh:mm"));
  mapPropsToValues: (props) => (
    {
      shipment_reference_no: (props.shipmentEdit ? props.shipmentEdit.shipment_reference_no : ""),
      required_on: (props.shipmentEdit ? props.shipmentEdit.required_on : ""),
      route_code: (props.shipmentEdit ? props.shipmentEdit.orders[0].shipment.route_code : ""),
      route_name: (props.shipmentEdit ? props.shipmentEdit.orders[0].shipment.route_name : ""),
      // proposed_vehicle_type: props.proposed_vehicle_type || "",
      source: (props.shipmentEdit ? props.shipmentEdit.route_details.source : ""),
      destination: (props.shipmentEdit ? props.shipmentEdit.route_details.destination : ""),
      no_of_vehicles: (props.shipmentEdit ? props.shipmentEdit.no_of_vehicles : ""),
      movement_type: (props.shipmentEdit ? props.shipmentEdit.movement_type : "primary"),
      // base_rate: props.base_rate, // Optional params should only be send to API if they contain some value.
      // remarks: props.shipmentEdit.remarks, // Optional params should only be send to API if they contain some value.
    }),
  handleSubmit(values, { setFieldValue, setSubmitting, props }) {
    if (props.mode == 'edit') {
      setSubmitting(true);
      let storeShipment = props.shipment
        ? props.shipment.create
          ? props.shipment.create
          : props.shipment
        : {};
      let shipments = Object.assign({}, storeShipment, values);
      props.createShipmentDispatcher(shipments, true);
      // TODO: move this call in redux
      if (
        props.shipment.create &&
        props.shipment.create.orders &&
        props.shipment.create.orders.length > 0
      ) {
        UpdateAxios({
          completeURL: `${process.env.REACT_APP_TA_API_URL}/shipments/${props.shipmentEdit.vendor_shipment_id}`,
          payload: { ...shipments },
        })
          .then((res) => {
            let alert = {
              type: "success",
              messageHeader: "Success",
              messageBody: res.data.message,
            };
            props.successAlertDispatcher(alert);
            props.onFormSubmit();
          })
          .catch((err) => {
            let alert = {
              type: "error",
              messageHeader: "Error",
              messageBody: err.response.data.error.message,
            };
            props.errorAlertDispatcher(alert);
          });
      }
    } else {
      setSubmitting(true);
      let storeShipment = props.shipment
        ? props.shipment.create
          ? props.shipment.create
          : props.shipment
        : {};
      let shipments = Object.assign({}, storeShipment, values);
      props.createShipmentDispatcher(shipments, true);
      // TODO: move this call in redux
      if (
        props.shipment.create &&
        props.shipment.create.orders &&
        props.shipment.create.orders.length > 0
      ) {
        // console.log('in FileCreatAxios', ...shipments)
        CreatAxios({
          completeURL: `${process.env.REACT_APP_TA_API_URL}/shipments`,
          payload: { ...shipments },
        })
          .then((res) => {
            let alert = {
              type: "success",
              messageHeader: "Success",
              messageBody: res.data.message,
            };
            props.successAlertDispatcher(alert);
            props.onFormSubmit();
          })
          .catch((err) => {
            let alert = {
              type: "error",
              messageHeader: "Error",
              messageBody: err.response.data.error.message,
            };
            props.errorAlertDispatcher(alert);
          });
      }
    }

  },
})(EditInsertShipment);

const mapStateToProps = ({ shipment }) => {
  return {
    shipment,
  };
};

export default connect(mapStateToProps, {
  createShipmentDispatcher,
  successAlertDispatcher,
  errorAlertDispatcher,
  deleteAllOrderDispatcher,
})(translate("create_shipment")(FormikEditShipment));
